import axios from "axios";
import qs from "qs";

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

export default {
  login(user) {
    return apiClient.post("/login", user);
  },
  logout(user) {
    return apiClient.post("/logout", user);
  },
  get(payload) {
    return apiClient.get(payload.url, { params: payload.params });
  },

  post(payload) {
    return apiClient.post(payload.url, qs.stringify(payload.data));
  },
  put(payload) {
    return apiClient.put(payload.url, qs.stringify(payload.data));
  },
  delete(payload) {
    return apiClient.delete(payload.url);
  },
  getFile(data) {
    return apiClient.get(data.url, {
      responseType: "arraybuffer"
    });
  },
  // getPdf(payload) {
  //   return apiClient.get(payload.url, {
  //     responseType: "arraybuffer"
  //   });
  // },
  getAcuse(data) {
    return apiClient.get(data.url, {
      responseType: "arraybuffer",
      params: data.data
    });
  },
};
